package org.example.project.service

import org.example.project.utils.All

object YardFlowApi {
    suspend fun fahrerAnkunftBestaetigen(
        auftrag: All,
        artCode: String,
        firmenId: String = ""
    ): All {
        return YardEngineApi.fahrerAngemeldet(auftrag, artCode, firmenId)
            ?: loadLatestAuftrag(auftrag, artCode, firmenId)
            ?: auftrag
    }

    suspend fun maNimmtAuftragAn(
        auftrag: All,
        artCode: String,
        firmenId: String = "",
        tor: All? = null,
        standortDetail: All? = null
    ): All {
        return YardEngineApi.maAnsTor(auftrag, artCode, firmenId, tor, standortDetail)
            ?: loadLatestAuftrag(auftrag, artCode, firmenId)
            ?: auftrag
    }

    suspend fun fahrerBestaetigtAngesetzt(
        auftrag: All,
        artCode: String,
        firmenId: String = ""
    ): All {
        return YardEngineApi.fahrerAngesetzt(auftrag, artCode, firmenId)
            ?: loadLatestAuftrag(auftrag, artCode, firmenId)
            ?: auftrag
    }

    suspend fun maBestaetigtPin(
        auftrag: All,
        artCode: String,
        firmenId: String = ""
    ): All {
        return YardEngineApi.pinBestaetigt(auftrag, artCode, firmenId)
            ?: loadLatestAuftrag(auftrag, artCode, firmenId)
            ?: auftrag
    }

    private suspend fun loadLatestAuftrag(auftrag: All, artCode: String, firmenId: String): All? {
        val providerFirmenId = firmenId.ifBlank { auftrag.firmenId }
        val liste = if (artCode == "WA") {
            YardApi.loadWaLkwListe(providerFirmenId)
        } else {
            YardApi.loadWeLkwListe(providerFirmenId)
        }
        return liste.firstOrNull { sameYardAuftrag(it, auftrag, artCode) }
    }

    private fun sameYardAuftrag(left: All, right: All, artCode: String): Boolean {
        if (artCode == "WA") {
            val sameTour = left.lieferscheinnummer.isNotBlank() &&
                right.lieferscheinnummer.isNotBlank() &&
                left.lieferscheinnummer == right.lieferscheinnummer
            if (!sameTour) return false
        }
        return (left.id.isNotBlank() && left.id == right.id) ||
            (left.lfdNr > 0 && right.lfdNr > 0 && left.lfdNr == right.lfdNr)
    }
}
